import { Framework } from "../models/BdaService";
import client from "./axios";

const frameworksUrl = `${window.__env.KRAKEND_URL}/v1/frameworks`;

export const Frameworks = {
  getFrameworks: (params?: URLSearchParams) => client.get<Framework[]>(frameworksUrl, { params }),
}